import { UserUid, OrganizationUid } from "@buildwithflux/models";
import { z } from "zod";
export const GetSharedWorkspacesRequest = z.object({
    otherUserUid: UserUid,
});
/**
 * The response to the getSharedWorkspaces function - a list of Organization UIDs that the current user and the other
 * user are both members of
 *
 * By definition, shared workspaces are always organizations that the current user belongs to, and so will have the
 * details of already loaded in their client store. That's why we only need to return the UIDs here.
 */
export const GetSharedWorkspacesResponse = z.object({
    organizationUids: z.array(OrganizationUid),
});
//# sourceMappingURL=organizations.js.map